export const aciMoneyCircle = {
    iconName: 'money-circle',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                },
            },
            {
                attr: {
                    d: 'M12.188 11.75c-1.19-.751-2.378-1.44-2.378-2.754 0-.938.688-1.69 1.502-1.69h3.191c.188 0 .313-.125.313-.312 0-.188-.125-.313-.313-.313h-2.19v-.939c0-.188-.125-.313-.313-.313s-.313.125-.313.313v.939h-.375c-1.19 0-2.128 1.064-2.128 2.315 0 1.69 1.377 2.503 2.629 3.255C13 13 14.19 13.69 14.19 15.004c0 .939-.688 1.69-1.501 1.69H9.497c-.188 0-.313.125-.313.313 0 .187.125.313.313.313h2.19v.938c0 .188.126.313.313.313.188 0 .313-.125.313-.313v-.938h.376c1.189 0 2.127-1.064 2.127-2.316 0-1.69-1.377-2.503-2.628-3.254z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
